<div class="flex flex-col items-center justify-center h-screen bg-[#f2f5f9] p-4">
  <div class="flex flex-col items-center max-w-2xl w-full">
    <mat-card class="w-full max-w-md p-6">
      <mat-card-content class="flex flex-col items-center">
        <div class="mb-6 flex justify-center w-full">
          <img
            src="assets/legal-resources-logo.png"
            alt="Legal Resources Logo"
            class="h-auto max-h-16 w-auto object-contain"
          />
        </div>

        <div class="flex flex-col gap-4 w-full">
          <h2 class="text-2xl font-bold text-center mb-2">{{ title() }}</h2>
          @if (subtitle()) {
            <p class="text-gray-600 text-center">{{ subtitle() }}</p>
          }

          <button
            mat-raised-button
            color="primary"
            (click)="login.emit()"
            class="w-full py-3">
            Login with Auth0
          </button>

          <ng-content />
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
